import prodConf from './production';
import devConf from './development';
import preprodConf from './preprod';

const secEnv = process.env.SECONDARY_ENV;

const environment = process.env.NODE_ENV !== 'production' ? 'development' : 'production';
let conf = environment === 'production' ? prodConf : devConf;

if (secEnv === 'preprod') {
	conf = preprodConf;
}

export default conf;
